import moment from 'moment';
import { bool } from 'prop-types';
import React, { useRef } from 'react';

import HoverDetails from '../../generic/HoverDetails';
import IconLink from '../../generic/IconLink';
import { associatedAgreementShape } from '../../prop-types';
import { withFullName } from '../../users/utils';
import { INTERNAL_DATE_FORMAT } from '../../utils/constants';

function AgreementLink({ model, showIcon, ...rest }) {
  const { id, name, salesUnit, type, startDate, endDate, owner } = model;
  const linkRef = useRef(null);

  return (
    <>
      <span ref={linkRef}>
        <IconLink showIcon={showIcon} to={`/agreements/${id}/show`} {...rest}>
          {name}
        </IconLink>
      </span>
      <HoverDetails
        linkRef={linkRef}
        size="large"
        title={name}
        fields={{
          'Sales Unit': salesUnit,
          Type: type,
          'Start and End Date': `${moment(startDate).format(
            INTERNAL_DATE_FORMAT,
          )} until ${moment(endDate).format(INTERNAL_DATE_FORMAT)}`,
          Owner: withFullName(owner).fullName || '-',
        }}
      />
    </>
  );
}

AgreementLink.propTypes = {
  model: associatedAgreementShape.isRequired,
  showIcon: bool,
};

AgreementLink.defaultProps = {
  showIcon: false,
};

export default AgreementLink;
